import React from 'react';
import Section from '../ui/Section';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const PainPoints = () => {
  const points = [
    { icon: FiIcons.FiAlertCircle, title: 'No clear standards' },
    { icon: FiIcons.FiCopy, title: 'Duplicated work' },
    { icon: FiIcons.FiShield, title: 'Safeguarding concerns' },
    { icon: FiIcons.FiHelpCircle, title: 'Staff uncertainty' },
    { icon: FiIcons.FiEyeOff, title: 'No oversight' },
    { icon: FiIcons.FiSliders, title: 'Inconsistent outputs' },
    { icon: FiIcons.FiDatabase, title: 'Data concerns' },
    { icon: FiIcons.FiCloudRain, title: 'Overwhelmed leadership' },
  ];

  return (
    <Section bg="white" className="border-y border-gray-100 py-24">
      <div className="max-w-3xl mx-auto text-center mb-16 px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-8">
          AI is already part of your organisation. The question is whether you're leading it.
        </h2>
        <div className="space-y-4 text-lg text-gray-600 leading-relaxed font-normal">
          <p>
            AI is already being used across your organisation. In emails, reports, and planning sessions.
          </p>
          <p>
            The risk is not that staff are experimenting. The risk is that no one has decided where AI belongs, where people should lead, and how your organisation should use it with confidence.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {points.map((point, index) => (
          <motion.div 
            key={index}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
            viewport={{ once: true }}
            className="bg-gray-50 rounded-2xl p-6 flex flex-col items-center text-center border border-gray-100 hover:border-brand-teal/30 hover:bg-white hover:shadow-sm transition-all duration-300"
          >
            <SafeIcon icon={point.icon} className="w-8 h-8 text-brand-teal mb-4 opacity-80" />
            <h3 className="font-bold text-brand-navy text-sm">{point.title}</h3>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default PainPoints;